import { createContext, ReactNode, useCallback, useContext, useState, } from "react";
import { UserDoc, UserSettings } from "ap-exerciser-sdk/models";

export type SettingsContextValueProps = {};


export type SettingsContextProps = SettingsContextValueProps & {
  profileData: UserDoc;
  setProfileData: (value: any) => void;
  settings: UserSettings;
  onSetSettings: (settings: any) => void;
  avatar: string | undefined;
  setAvatar: (avatar: string) => void;
  skin: any;
  setSkin: (skin: any) => void;
  onUpdateSettings: (field: string, value: string | boolean) => void;
  settingModalOpen: boolean;
  setSettingModalOpen: (open: boolean) => void;
  profileOpen: boolean;
  setProfileOpen: (open: boolean) => void;
  defaultProfileTab: number;
  setDefaultProfileTab: (tabIndex: number) => void;
  settingsTabIndex: number,
  setSettingsTabIndex: (tabIndex: number) => void,
};

const initialState: SettingsContextProps = {
  profileData: null!,
  setProfileData: () => {},
  settings: null!,
  onSetSettings: () => {},
  avatar: undefined,
  setAvatar: () => {},
  skin: null,
  setSkin: () => {},
  onUpdateSettings: () => {},
  settingModalOpen: false,
  setSettingModalOpen: () => {},
  profileOpen: false,
  setProfileOpen: () => {},
  defaultProfileTab: 0,
  setDefaultProfileTab: () => {},
  settingsTabIndex: 0,
  setSettingsTabIndex: () => {},
};

export const SettingsContext = createContext(initialState);

type SettingsProviderProps = {
  children: ReactNode;
};

export function SettingsProvider({ children }: SettingsProviderProps) {
  const [profileData, setProfileData] = useState<UserDoc>(null!);
  const [settings, setSettings] = useState<UserSettings>(null!);
  const [settingModalOpen, setSettingModalOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [defaultProfileTab, setDefaultProfileTab] = useState(0);
  const [settingsTabIndex, setSettingsTabIndex] = useState(0);
  const [avatar, setAvatar] = useState<string>();
  const [skin, setUserSkin] = useState();

  const onSetSettings = useCallback((settings: any) => {setSettings(settings)}, [setSettings, settings]);
  const setSkin = useCallback((skin: any) => {setUserSkin(skin)}, [setUserSkin]);

  const onUpdateSettings = useCallback(
    (field: string, value: string | boolean) => {
      setSettings((currentSettings) => ({
        ...currentSettings,
        [field]: value,
      }));
    },
    [setSettings, settings]
  );

  return (
    <SettingsContext.Provider value={{
      profileData,
      setProfileData,
      settings,
      onSetSettings,
      avatar,
      setAvatar,
      skin,
      setSkin,
      onUpdateSettings,
      settingModalOpen,
      setSettingModalOpen,
      profileOpen,
      setProfileOpen,
      defaultProfileTab,
      setDefaultProfileTab,
      settingsTabIndex,
      setSettingsTabIndex,
    }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettingsContext = () => useContext(SettingsContext);
